module.exports = __webpack_public_path__ + "img/icon_gongneng10.4d40b36d.svg";